"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useComboboxPopup", {
    enumerable: true,
    get: ()=>useComboboxPopup
});
const _reactPositioning = require("@fluentui/react-positioning");
const _reactUtilities = require("@fluentui/react-utilities");
function useComboboxPopup(props, triggerShorthand, listboxShorthand) {
    const { positioning  } = props;
    // Set a default set of fallback positions to try if the dropdown does not fit on screen
    const fallbackPositions = [
        'above',
        'after',
        'after-top',
        'before',
        'before-top'
    ];
    // popper options
    const popperOptions = {
        position: 'below',
        align: 'start',
        offset: {
            crossAxis: 0,
            mainAxis: 2
        },
        fallbackPositions,
        ...(0, _reactPositioning.resolvePositioningShorthand)(positioning)
    };
    const { targetRef , containerRef  } = (0, _reactPositioning.usePositioning)(popperOptions);
    const listboxRef = (0, _reactUtilities.useMergedRefs)(listboxShorthand === null || listboxShorthand === void 0 ? void 0 : listboxShorthand.ref, containerRef);
    const listbox = listboxShorthand && {
        ...listboxShorthand,
        ref: listboxRef
    };
    return [
        {
            ...triggerShorthand,
            ref: (0, _reactUtilities.useMergedRefs)(triggerShorthand === null || triggerShorthand === void 0 ? void 0 : triggerShorthand.ref, targetRef)
        },
        listbox
    ];
} //# sourceMappingURL=useComboboxPopup.js.map

//# sourceMappingURL=useComboboxPopup.js.map